import { createContext } from 'react';

const LottoAssistantIntentsContext = createContext({
  handleQuickPick: () => {},
  handleBrowseLotteries: () => {},
  handleMyBets: () => {},
  handleBettingOptionsRequest: () => {},
  handleLottoResults: () => {},
  handleDetailedLotteryResults: () => {},
  handleOutcomeSelect: () => {},
  handleLotterySelect: async () => {},
  stageTickets: () => {},
  stageLotteryId: () => {},
  stageLotteryList: () => {},
});

export default LottoAssistantIntentsContext;
